import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=7218dcc5&scoped=true&"
import script from "./MessageList.vue?vue&type=script&lang=js&"
export * from "./MessageList.vue?vue&type=script&lang=js&"
import style0 from "./MessageList.vue?vue&type=style&index=0&id=7218dcc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7218dcc5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/q7gCdwre/0/h5group/renpho-lex/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7218dcc5')) {
      api.createRecord('7218dcc5', component.options)
    } else {
      api.reload('7218dcc5', component.options)
    }
    module.hot.accept("./MessageList.vue?vue&type=template&id=7218dcc5&scoped=true&", function () {
      api.rerender('7218dcc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MessageList.vue"
export default component.exports